import { ShopifySearch } from "./shopify-search.js";
import { l as layout } from "./layout-store.js";
import { d as debounce } from "./lodash-utils.js";
import { ShopifyCart } from "./shopify-cart.js";
import { ShopifyFiltering } from "./shopify-filtering.js";
import "./scrollControl.js";
import "./preact-core.js";
import "./utilities.js";
class QuickAddButton extends HTMLElement {
  constructor() {
    super();
    this.url = null;
    this.variantId = null;
    this.availability = false;
    this.price = null;
    this.loading = false;
    this.selectedVariant = null;
    this.variantStrings = null;
    this.errorMessage = "";
    this.submitButton = null;
    this.quantity = 1;
    this.quantityEl = null;
    this.layout = layout;
    this.quantity = 1;
    this.variantId = this.dataset.variantId;
    this.availability = this.dataset.available === "true";
    this.submitButton = this.querySelector(".quick-add__button");
    this.url = this.dataset.url;
    if (this.querySelector('input[name="quantity"]')) {
      this.quantityEl = this.querySelector('input[name="quantity"]');
    }
    if (this.quantityEl) {
      this.quantityEl.addEventListener(
        "change",
        this.handleQuantityChange.bind(this)
      );
    }
    this.submitButton.addEventListener("click", this.handleSubmit.bind(this));
  }
  handleQuantityChange(evt) {
    this.quantity = evt.target.value;
  }
  async handleSubmit(evt) {
    console.log("handleSubmit", this.variantId, this.quantity);
    evt.preventDefault();
    if (!this.availability) return;
    this.errorMessage = "";
    this.loading = true;
    const body = JSON.stringify({
      items: [
        {
          id: this.variantId,
          quantity: Number(this.quantity)
        }
      ]
    });
    this.layout.cartAddItem(body).then((response) => {
      console.log("response", response);
      if (response.status) {
        this.errorMessage = response.description;
        this.availability = false;
        return;
      }
      this.layout.slideover.value = "cart";
    }).catch((e) => {
      this.loading = false;
      console.error(e);
    }).finally(() => {
      this.loading = false;
    });
  }
}
if (!customElements.get("quick-add-button")) {
  customElements.define("quick-add-button", QuickAddButton);
}
class QtyControl extends HTMLElement {
  constructor() {
    var _a, _b, _c, _d;
    super();
    this.emitChange = debounce(() => {
      this.layout.updateQuantity(this.line, this.inputEl.value);
    }, 300);
    this.layout = layout;
    this.inputEl = this.querySelector(".quantity__input");
    this.minusBtn = this.querySelector(".quantity__button[name='minus']");
    this.plusBtn = this.querySelector(".quantity__button[name='plus']");
    this.line = this.dataset.line;
    (_a = this.minusBtn) == null ? void 0 : _a.addEventListener("click", (e) => {
      e.preventDefault();
      this.decreaseQty();
    });
    (_b = this.minusBtn) == null ? void 0 : _b.addEventListener("touchstart", (e) => {
      e.preventDefault();
      this.decreaseQty();
    });
    (_c = this.plusBtn) == null ? void 0 : _c.addEventListener("click", (e) => {
      e.preventDefault();
      this.increaseQty();
    });
    (_d = this.plusBtn) == null ? void 0 : _d.addEventListener("touchstart", (e) => {
      e.preventDefault();
      this.increaseQty();
    });
  }
  decreaseQty() {
    this.inputEl.value = Math.max(
      parseFloat(this.inputEl.value) - 1,
      0
    ).toString();
    this.emitChange();
  }
  increaseQty() {
    this.inputEl.value = (parseFloat(this.inputEl.value) + 1).toString();
    this.emitChange();
  }
}
if (!customElements.get("qty-control")) {
  customElements.define("qty-control", QtyControl);
}
class QuickRemoveButton extends HTMLElement {
  constructor() {
    var _a;
    super();
    this.loading = false;
    this.errorMessage = "";
    this.layout = layout;
    this.button = this.querySelector("button");
    this.line = parseFloat((_a = this.button) == null ? void 0 : _a.dataset.line);
    this.bundle = this.dataset.bundle;
    this.button.addEventListener("click", this.handleSubmit.bind(this));
  }
  async handleSubmit(evt) {
    evt.preventDefault();
    this.closest(".cart-item").classList.add("updating");
    this.errorMessage = "";
    this.loading = true;
    if (this.bundle) {
      this.layout.removeBundle(this.bundle).catch((e) => {
        console.error(e);
      }).finally(() => {
        this.loading = false;
      });
    } else {
      this.layout.updateQuantity(this.line, 0).catch((e) => {
        console.error(e);
      }).finally(() => {
        this.loading = false;
      });
    }
  }
}
if (!customElements.get("quick-remove-button")) {
  customElements.define("quick-remove-button", QuickRemoveButton);
}
customElements.define("quick-add-button", QuickAddButton);
customElements.define("qty-control", QtyControl);
customElements.define("quick-remove-button", QuickRemoveButton);
customElements.define("shopify-cart", ShopifyCart);
customElements.define("shopify-search", ShopifySearch);
customElements.define("shopify-filtering", ShopifyFiltering);
